import { TextField } from '@mui/material';

export default function BasicFields({ title, text, saving, onTitleChange, onTextChange }) {
  return (
    <>
      <TextField
        label="Title"
        value={title}
        onChange={(e) => onTitleChange(e.target.value)}
        fullWidth
        disabled={saving}
      />

      <TextField
        label="Text"
        value={text}
        onChange={(e) => onTextChange(e.target.value)}
        fullWidth
        multiline
        rows={5}
        disabled={saving}
      />
    </>
  );
}